import { useEffect, useMemo, useContext, useState, useCallback } from 'react';
import { callautopopulate } from '../../../services/callautopop.js';
import _ from 'underscore';
import { InputSwitch } from 'primereact/inputswitch';
import services from '../../../services/services.js';
import { Urls } from '../../../services/Urls.js';
import { ToastContext } from '../../../context/ToastContext.js';

export const useCategoryControlCenter = () => {
    const { showSuccess, showError } = useContext(ToastContext);
    const [category, setCategory] = useState([]);
    const [innerColumns, setInnerColumns] = useState([]);
    const [loader, setLoader] = useState(false);
    const [treeData, setTreeData] = useState([]);
    const [data, setData] = useState([]);
    const [userCode, setUserCode] = useState("");
    const [expandedKeys, setExpandedKeys] = useState({});


    useEffect(() => {
        callautopopulate("user_category", "user_info").then(res => {
            setUserCode(res?.user_info[0]?.user_code)
            const category = _.sortBy(res?.user_category, "user_category_name")
            setCategory(category)
            const categoryObj = []
            category?.forEach((value) => {
                categoryObj.push({ ...value, name: "View" })
                categoryObj.push({ ...value, name: "Edit" })
            })
            setInnerColumns(categoryObj)
        });
        getcategoryPermissons();
    }, []);

    const buildTree = (resources) => {
        const resourceMap = {};
        resources.forEach((resource) => {
            const obj = {
                key: resource.resource_key,
                data: resource,
            };
            if (!_.isEmpty(_.where(resources, { parent_resource_key: resource.resource_key }))) {
                obj["children"] = [];
            }
            resourceMap[resource.resource_key] = obj;
        });
        const result = [];
        resources.forEach((resource) => {
            const currentResource = resourceMap[resource.resource_key];
            if (resource?.parent_resource_key) {
                const parentResource = resourceMap[resource.parent_resource_key];
                if (parentResource) {
                    parentResource.children.push(currentResource);
                }
            } else {
                result.push(currentResource);
            }
        });
        return result;
    };
    const getcategoryPermissons = useCallback(async () => {
        setLoader(true)
        try {
            const payload = { "user_category_id": 0 };
            const res = await services.getInvokeRemote('POST', Urls('GETCATEGORYWISERESOURCEPERMISSIONS'), payload)
            if (res?.body?.data?.resourcePermission) {
                const result = _.uniq(res.body.data.resourcePermission, "resource_key");
                const resultData = []
                result?.forEach((values) => {
                    const CategoryWiseResource = _.filter(res.body.data.resourcePermission, { resource_id: values?.resource_id })
                    const obj = { ...values }
                    delete obj.user_category_name
                    delete obj.user_category_id

                    CategoryWiseResource?.map((value) => {
                        obj[value?.user_category_name?.replaceAll(" ", "_")] = value
                    })
                    resultData.push(obj)
                })
                setData(_.sortBy(resultData, "resource_name"))
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error(error);
        }
    }, []);

    useEffect(() => {
        if (data?.length > 0) {
            const tree = buildTree(_.sortBy(data, "resource_name"));
            setTreeData(tree)
        }
    }, [data])

    const assignGridTemplate = (rowData, category) => {
        const getData = rowData?.data[category?.replaceAll(" ", "_")]
        return (
            <div className="text-center input-switch">
                <InputSwitch
                    checked={getData?.is_active}
                    onChange={(e) => handleChange(e.value, rowData, category, "is_active")}
                />
            </div>
        )
    };


    const assignGridBodyTemplate = (rowData, category) => {
        const getData = rowData?.data[category?.replaceAll(" ", "_")]
        return (
            <div className="text-center input-switch">
                <InputSwitch
                    checked={getData?.is_editable}
                    onChange={(e) => handleChange(e.value, rowData, category, "is_editable")}
                />
            </div>
        );
    };
    const handleChange = async (newValue, rowData, category, key) => {
        const categoryKey = category.replaceAll(" ", "_");
        const CategoryData = rowData?.data?.[categoryKey];
        const permissionsData = {
            "is_active": key === "is_active" ? newValue : (key === "is_editable" && newValue) ? newValue : CategoryData?.is_active !== null ? CategoryData?.is_active : false,
            "is_editable": (key === "is_active" && !newValue) ? newValue : key === "is_editable" ? newValue : CategoryData?.is_editable !== null ? CategoryData?.is_editable : false,
            "parent_resource_key": CategoryData?.parent_resource_key,
            "resource_key": CategoryData?.resource_key,
            "resource_name": CategoryData?.resource_name
        }
        try {
            const payload = {
                'permissions': [permissionsData],
                "user_category_id": CategoryData?.user_category_id,
                'modify_user_code': userCode
            };
            const response = await services.getInvokeRemote('POST', Urls('UPSERTRESOURCEPERMISSIONS'), payload)
            if (response.body.data) {
                showSuccess('Success', response.body.message)
                const newData = data.map(item => {
                    if (item.resource_id === rowData?.data?.resource_id) {
                        const updatedCategory = {
                            ...item[categoryKey],
                            [key]: newValue,
                            ...(key === "is_active" && !newValue ? { is_editable: false } : {}),
                            ...(key === "is_editable" && newValue ? { is_active: true } : {})
                        };

                        return {
                            ...item,
                            [categoryKey]: updatedCategory
                        };
                    }
                    return item;
                });
                setData(newData);
            } else {
                showError('Error', response.body.errorMessage)
            }
        } catch (error) {
            console.error(error);
        }
    };


    useEffect(() => {
        if (treeData && treeData.length > 0) {
            setExpandedKeys(prevKeys => {
                const updatedKeys = { ...prevKeys };
                let keysAdded = false;
                treeData.forEach((node) => {
                    if (updatedKeys[node.key] === undefined) {
                        updatedKeys[node.key] = true;
                        keysAdded = true;
                    }
                });
                return keysAdded ? updatedKeys : prevKeys;
            });
        }
    }, [treeData]);



    return useMemo(() => ({
        category, innerColumns, treeData, assignGridBodyTemplate, assignGridTemplate, loader, getcategoryPermissons, expandedKeys, setExpandedKeys
    }), [category, innerColumns, treeData, assignGridBodyTemplate, assignGridTemplate, loader, getcategoryPermissons, expandedKeys])
}